import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import { auth, saveAuth, clearAuth } from './auth'
import { fetchMe } from './services/api'

// 1) Estilos do Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// 2) Importar traduções
import pt from './locales/pt'
import en from './locales/en'
import es from './locales/es'
import fr from './locales/fr'
import de from './locales/de'

const messages = { pt, en, es, fr,de }

// 3) Configurar Vue I18n
const i18n = createI18n({
  locale: localStorage.getItem('locale') || 'pt',
  fallbackLocale: 'pt',
  messages
})

// 4) Forçando tema escuro por padrão
if (typeof localStorage !== 'undefined') {
  localStorage.setItem('app-theme', 'dark')
}

// 5) Configurar Vuetify
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: 'dark'
  }
})

// 6) Montar aplicação
const app = createApp(App)
app.use(router)
app.use(vuetify)
app.use(i18n)

// 7) Tentar restaurar sessão ao carregar
if (auth.token) {
  fetchMe(auth.token)
    .then(res => {
      if (res.user) saveAuth(auth.token, res.user)
      else clearAuth()
    })
    .catch(() => clearAuth())
}

app.mount('#app')
